export const APP_VERSION = '9d31eab';
